import { render } from "./AppSettings.vue?vue&type=template&id=5e57aed6&scoped=true"
import script from "./AppSettings.vue?vue&type=script&lang=js"
export * from "./AppSettings.vue?vue&type=script&lang=js"

import "./AppSettings.vue?vue&type=style&index=0&id=5e57aed6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e57aed6"]])

export default __exports__